import React from 'react';

import { Toolbar } from '@devexpress/dx-react-grid-material-ui';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  root: {
    '& > div:first-child': {
      display: 'none'
    }
  }
});

const CustomToolbarRoot = (props) => {
  const classes = useStyles();

  return <Toolbar.Root {...props} className={classes.root} />;
};

export default CustomToolbarRoot;
